module.exports = __webpack_public_path__ + "static/media/icon4.d6218c09.svg";